/*eslint-disable*/
import React from "react";

// reactstrap components
import { Container } from "reactstrap";

// core components

function DefaultFooter() {
  return (
    <>
      <footer className="footer footer-default">
        <Container>
          <nav>
            <ul>
              <li>
                <a
                  href="/yoga-in-hanoi"
                >
                  MoonYoga
                </a>
              </li>
              <li>
                <a
                  href="/yoga-in-hanoi"
                >
                  Hanoi Yoga
                </a>
              </li>
              <li>
                <a
                  href="/yoga-teacher-training"
                >
                  Yoga Teacher Trainings in Vietnam
                </a>
              </li>
            </ul>
          </nav>
          <div className="copyright" id="copyright">
            © 2023
            MoonYoga. All Rights Reserved.             .
          </div>
        </Container>
      </footer>
    </>
  );
}

export default DefaultFooter;
